import {
  provideRouter, withComponentInputBinding, withDisabledInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';

import { ApplicationConfig } from '@angular/core';
import { getCommonProviders } from './app.config.common';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    ...getCommonProviders('browser'),

    provideRouter(
      routes,
      withComponentInputBinding(),
      withDisabledInitialNavigation(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    )
  ]
};

